const dateParse = (dateString: string): string =>
  new Date(dateString).toLocaleString(undefined, {
    timeZoneName: 'short',
  });

export default dateParse;
